import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import CompareBar from "@/components/CompareBar";
import IntroGate from "@/components/IntroGate";
import QuickAddModal from "@/components/QuickAddModal";
import "@/App.css";

// Route-level code splitting: only the homepage ships in the initial bundle.
const Category = lazy(() => import("@/pages/Category"));
const Subcategory = lazy(() => import("@/pages/Subcategory"));
const CategoryProducts = lazy(() => import("@/pages/CategoryProducts"));
const ProductDetail = lazy(() => import("@/pages/ProductDetail"));
const ServiceDetail = lazy(() => import("@/pages/ServiceDetail"));
const VarmalaDetail = lazy(() => import("@/pages/VarmalaDetail"));
const Selection = lazy(() => import("@/pages/Selection"));
const ShareVision = lazy(() => import("@/pages/ShareVision"));
const Booking = lazy(() => import("@/pages/Booking"));
const Login = lazy(() => import("@/pages/Login"));
const Signup = lazy(() => import("@/pages/Signup"));
const MyBookings = lazy(() => import("@/pages/MyBookings"));
const Account = lazy(() => import("@/pages/Account"));
const Admin = lazy(() => import("@/pages/Admin"));
const Search = lazy(() => import("@/pages/Search"));
const Recommend = lazy(() => import("@/pages/Recommend"));
const Wishlist = lazy(() => import("@/pages/Wishlist"));
const Compare = lazy(() => import("@/pages/Compare"));
const Journey = lazy(() => import("@/pages/Journey"));
const VenuesComingSoon = lazy(() => import("@/components/VenuesComingSoon"));
const CreateEvent = lazy(() => import("@/pages/CreateEvent"));
const CreateEventMoodboard = lazy(() => import("@/pages/CreateEventMoodboard"));

const Fallback = () => <div data-testid="route-loading" className="min-h-[50vh] flex items-center justify-center text-sm text-[#8a837a]">Loading…</div>;

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <IntroGate />
        <Layout>
          <Suspense fallback={<Fallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/category/:main" element={<Category />} />
              <Route path="/category/:main/:sub" element={<Subcategory />} />
              <Route path="/category/:main/:sub/:cat" element={<CategoryProducts />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/services/:id" element={<ServiceDetail />} />
              <Route path="/varmala/:tileId" element={<VarmalaDetail />} />
              <Route path="/selection" element={<Selection />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/my-bookings" element={<MyBookings />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/search" element={<Search />} />
              <Route path="/recommend" element={<Recommend />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/journey/:main/:sub" element={<Journey />} />
              <Route path="/venues" element={<VenuesComingSoon />} />
              <Route path="/venues/region/:region" element={<VenuesComingSoon />} />
              <Route path="/venues/:id" element={<VenuesComingSoon />} />
              <Route path="/share-vision" element={<ShareVision />} />
              <Route path="/create-event" element={<CreateEvent />} />
              <Route path="/create-event/moodboard" element={<CreateEventMoodboard />} />
              <Route path="/create-event/:main" element={<CreateEvent />} />
              <Route path="/create-event/:main/:sub" element={<Journey />} />
            </Routes>
          </Suspense>
          <CompareBar />
          <QuickAddModal />
        </Layout>
      </BrowserRouter>
    </AppProvider>
  );
}
